import { render } from "./DownloadChatGPT.vue?vue&type=template&id=4729ed24"
import script from "./DownloadChatGPT.vue?vue&type=script&lang=js"
export * from "./DownloadChatGPT.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__